import React from "react";
import {Event} from "../../../../cp/components/Comet";
import {useEventContext} from "../EventContext";

export default () => {
    const {pagesDispatch} = useEventContext();

    function onUpdatePage(data) {
        pagesDispatch((pages) => (pages.map((page) => {
                return page.id === data.id ? data : page;
            })
        ));
    }

    return (
        <>
            <Event event="update:page" handler={(data) => onUpdatePage(data)} />
        </>
    );
}